import React from 'react';
import { Grid, Card, CardContent } from '@material-ui/core';
import Logo from 'assets/podlink-logo-full.png'

import useStyles from '../styles/FullScreenCard';

interface Props {
  footer?: React.ReactNode;
  isMini?: boolean;
  size?: 'normal' | 'small' | 'mini';
  isNested?: boolean;
  showOverlay?: boolean;
  hideLogo?: boolean;
};

const FullScreenCard: React.SFC<Props> = ({ size = 'normal', ...restOfProps }) => {
  const { children, isMini, footer, isNested, hideLogo, showOverlay } = restOfProps;
  const classes = useStyles({ isMini, size, isNested });
  const overlayClasses = showOverlay ? classes.overlay : '';

  return (
    <Grid
      className={`${classes.root} ${overlayClasses}`}
      container
      direction="column"
      alignContent="center"
      alignItems="center"
      justify="center"
      spacing={2}
    >
      {!hideLogo && (
        <Grid item>
          <img src={Logo} alt="Podlink Logo" />
        </Grid>
      )}
      <Grid item>
        <Card className={classes.card}>
          <CardContent className={classes.cardContent}>
            {children}
          </CardContent>
        </Card>
      </Grid>
      {footer && (
        <Grid item className={classes.footer}>
          {footer}  
        </Grid>
      )}
    </Grid>
  );
}

export default FullScreenCard;
